<template>
    <div style="text-align: center">
        <div :style="{color: option.attribute.numColor,fontSize:option.attribute.numSize+'px', lineHeight:option.attribute.numHeight+'px',fontWeight:option.attribute.numFontWeight}"
             style="font-family:'840CAI978',serif">
            {{ cptData.value }}<span style="font-size: 14px;color: #ccc">{{ (cptData.unit ? cptData.unit : '') }}</span>
        </div>
        <div :style="{color: option.attribute.textColor,fontSize:option.attribute.textSize+'px'}">{{ option.attribute.title }}</div>
    </div>
</template>

<script>
import {getDataJson, pollingRefresh} from "@/utils/refreshCptData";

export default {
    name: "cpt-num",
    props: {
        option: Object
    },
    inject: ['queryParam'],
    data() {
        return {
            cptData: {},
            uuid: null
        }
    },
    created() {
        this.uuid = require('uuid').v1();
        this.refreshCptData();
    },
    methods: {
        refreshCptData() {
            pollingRefresh(this.uuid, this.option.cptDataForm, this.loadData)
        },
        loadData() {
            getDataJson(this.option.cptDataForm, this.queryParam, "Num").then(res => {
                this.cptData = res;
            });
        },
    }
}
</script>

<style scoped>

</style>
